import {
    ADD_VALUE_TO_EXPIRING_CONVOS,
    REMOVE_VALUE_FROM_EXPIRING_CONVOS,
} from './constants'

export default (state = {}, action) => {
    let newState = {}
    switch (action.type) {
        case ADD_VALUE_TO_EXPIRING_CONVOS:
            {
                const { payload } = action
                let { expiringConvos } = state

                if (!expiringConvos) {
                    expiringConvos = []
                }

                if (!expiringConvos.includes(payload)) {
                    expiringConvos.push(payload)
                }

                newState = {
                    ...state,
                    expiringConvos,
                }
            }
            break
        case REMOVE_VALUE_FROM_EXPIRING_CONVOS:
            {
                const { payload } = action
                const { expiringConvos } = state

                if (expiringConvos && expiringConvos.includes(payload)) {
                    expiringConvos.pop(payload)
                }

                newState = {
                    ...state,
                    expiringConvos,
                }
            }
            break
        default:
            newState = state
            break
    }

    return newState
}
